export const ROLES = {
    ADMIN: 'Admin',
    PARENT: 'Parent',
    TEACHER: 'Teacher'
}